module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_library.js
// module id = vAVS
// module chunks = 15